export default __webpack_public_path__ + "static/media/red-4.29161b41.svg";